import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customPipe', // Nombre con el que se usará en los templates
})
export class CustomPipe implements PipeTransform {
  transform(value: Date | string | undefined): string {
    if (!value) return ''; // Manejo de valores vacíos o nulos

    const dateString = value.toString();

    // Check if the string has a timezone offset (e.g., +02:00, +01:00, or Z)
    // If so, extract the local time directly without UTC conversion
    if (dateString.includes('T')) {
      // Split on timezone indicators: +, -, or Z
      const dateTimePart = dateString.split('+')[0].split('Z')[0];

      // Handle negative timezone offsets (though unlikely for Spain)
      const parts = dateTimePart.split('T');
      if (parts.length === 2) {
        const [datePart, timePart] = parts;
        const [year, month, day] = datePart.split('-');
        const timeComponents = timePart.split(':');

        if (timeComponents.length >= 2) {
          const [hours, minutes, secondsWithMs] = timeComponents;
          const seconds = secondsWithMs ? secondsWithMs.substring(0, 2) : '00';

          // Format as DD/MM/YYYY HH:MM:SS
          return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }
      }
    }

    // Fallback: try to parse as a date
    const tempDate = new Date(value);
    if (isNaN(tempDate.getTime())) return 'Fecha inválida';

    // Extract components from the Date object
    const day = String(tempDate.getDate()).padStart(2, '0');
    const month = String(tempDate.getMonth() + 1).padStart(2, '0');
    const year = tempDate.getFullYear();
    const hours = String(tempDate.getHours()).padStart(2, '0');
    const minutes = String(tempDate.getMinutes()).padStart(2, '0');
    const seconds = String(tempDate.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }
}
